import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

type KeywordsImportErrorAlertProps = {
    onDismiss: () => void;
};

export const KeywordsImportErrorAlert = ({ onDismiss }: KeywordsImportErrorAlertProps) => {
    return (
        <Flex
            padding="8px 12px"
            gap="8px"
            marginY="12px 0"
            alignItems="center"
            width="100%"
            justifyContent="space-between"
            background={colorsPalettes.red[100]}
        >
            <Flex
                alignItems="center"
                gap="8px"
            >
                <SWReactIcons
                    iconName="error-info"
                    iconColor={colorsPalettes.red[500]}
                    size="xs"
                />
                <Text fontVariant="body2">{translate("seo.keywordsCampaign.wizard.addingKeywords.importError")}</Text>
            </Flex>
            <IconButton
                type={"flat"}
                iconName="clear"
                iconSize="xs"
                onClick={onDismiss}
            />
        </Flex>
    );
};
